import { Component, Input, OnInit } from '@angular/core';
import { CompanyBondModel } from '@data-layer/models/companies';
import { AbstractControl } from '@angular/forms';
import { enumBondType } from '@data-layer/enums/common';
import { enumCardStyle } from '@shared/cards/enums';

@Component({
  selector: 'company-bond-card',
  templateUrl: './company-bond-card.component.html',
  styleUrls: ['./company-bond-card.component.scss'],
})
export class CompanyBondCardComponent implements OnInit {
  @Input() public bond: CompanyBondModel;
  @Input() public id: string | number = 0;
  @Input() public fc: AbstractControl;
  @Input() public defaultBond: string;
  @Input() public isShowStatusTag: boolean = false;

  public cardStyle: enumCardStyle = enumCardStyle.SECONDARY;

  constructor() {}

  public ngOnInit(): void {}

  public get bondName() {
    return this.bond.type === enumBondType.CONTINUOUS
      ? 'BOND_TYPE.CONTINUOUS'
      : this.bond.type === enumBondType.SINGLE_TRANSACTION
      ? 'BOND_TYPE.SINGLE_TRANSACTION'
      : '';
  }
}
